import React from "react";

export const EmptyConversationWindow = () => {
  return (
    <div
      className="sms-preview__conversation"
      role="log"
      aria-label="Empty conversation"
    />
  );
};
